<template>
  <v-dialog max-width="400" v-model="dialogModel" @keydown="controlEsc" @click:outside="close">
    <v-card class="container-guest py-2" color="#21343b" width="auto">
      <v-stepper v-model="e1">
        <v-stepper-items>
          <v-stepper-content step="1">
            <v-row no-gutters align="center" justify="center">
              <v-col id="guest-in-col-area" class="px-5 mt-2" :cols="12" align="start" justify="start">
                <span class="txt-guest-title">{{ 'Hi👋, What’s your name?' }}</span>
              </v-col>
              <v-col class="px-5 mt-2 mb-5" :cols="12" align="start" justify="start">
                <!-- name -->
                <span class="txt-guest-desc-name">
                  {{ 'Let others know who posted it. Or you can ' }}
                  <!-- <span class="txt-guest-accent pointer" @click="setSignUp">
                    {{ 'sign up' }}
                  </span>
                  {{ ' or ' }} -->
                  <span class="txt-guest-accent pointer" @click="setSignIn">
                    {{ 'sign in.' }}
                  </span>
                  {{ ' By clicking ‘Next’ button, you agree to our ' }}
                  <span class="txt-guest-bold" v-html="TermsofService"></span>
                  {{ ' and ' }}
                  <span class="txt-guest-bold" v-html="PrivacyPolicy"></span>
                </span>
              </v-col>
            </v-row>
            <v-row no-gutters align="center" justify="center">
              <v-text-field
                id="guest-in-name-text-field"
                v-model="guestName"
                dense
                background-color="#1A272E"
                filled
                solo
                dark
                placeholder="Enter your name"
                autofocus
                class="px-4"
                :rules="[rules.required, rules.counter]"
              />
            </v-row>
            <v-row class="px-4 mt-1 mb-4" no-gutters align="center" justify="center">
              <v-col align="center" no-gutters>
                <v-btn block dark class="mr-2 white1--text" color="#6c6c6c" @click="close">
                  {{ $t('cancel') }}
                </v-btn>
              </v-col>
              <v-col class="ml-5" align="center" no-gutters>
                <v-btn block :disabled="!nameActive" class="white1--text" color="#289067" @click="nextName">
                  {{ $t('next') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-stepper-content>

          <v-stepper-content step="2">
            <v-row no-gutters align="center" justify="center">
              <v-col class="px-5 mt-2" :cols="12" align="start" justify="start">
                <span class="txt-guest-title">{{ 'Hey' }} {{ guestName }} {{ ' 👋' }}</span>
                <span class="txt-guest-title" style="display: block">{{ 'What’s your email?' }}</span>
              </v-col>
              <v-col class="px-5 mt-2 mb-5" :cols="12" align="start" justify="start">
                <!-- email -->
                <span class="txt-guest-desc-email">
                  {{ 'We will notify you when there are new messages or comments.' }}
                </span>
              </v-col>
            </v-row>
            <v-row no-gutters align="center" justify="center">
              <v-text-field
                id="guest-in-email-text-field"
                ref="guestEmailInput"
                v-model="guestEmail"
                dense
                background-color="#1A272E"
                filled
                solo
                dark
                placeholder="Enter your email"
                autofocus
                class="px-4"
                :rules="[rules.email]"
              />
            </v-row>
            <v-row class="px-4 mt-1 mb-4" no-gutters align="center" justify="center">
              <v-col align="center" no-gutters>
                <v-btn block dark class="mr-2 white1--text" color="#6c6c6c" @click="e1 = 1">
                  {{ $t('cancel') }}
                </v-btn>
              </v-col>
              <v-col class="ml-5" align="center" no-gutters>
                <v-btn
                  :disabled="!emailActive"
                  :loading="isSendCodeLoading"
                  block
                  class="white1--text"
                  color="#289067"
                  @click="setVerifyCode"
                >
                  {{ $t('continue') }}
                </v-btn>
              </v-col>
              <!-- <v-col v-else class="ml-5" align="center" no-gutters>
                <v-btn
                  id="skip-btn"
                  :loading="isGuestLogin"
                  block
                  class="white1--text"
                  color="#6c6c6c"
                  @click="skipEmail"
                >
                  {{ $t('skip') }}
                </v-btn>
              </v-col> -->
            </v-row>
          </v-stepper-content>

          <v-stepper-content step="3">
            <v-row no-gutters align="center" justify="center">
              <v-col class="px-5 mt-2" :cols="12" align="start" justify="start">
                <span class="txt-guest-title">{{ 'Check your inbox ✉️' }}</span>
              </v-col>
              <v-col class="px-5 mt-2 mb-5" :cols="12" align="start" justify="start">
                <!-- verification -->
                <span class="txt-guest-desc-verification">
                  {{ 'We’ve just sent a verification code. Please check your inbox!' }}
                </span>
              </v-col>
            </v-row>
            <v-row no-gutters align="center" justify="center">
              <v-text-field
                v-model="otp"
                dense
                background-color="#1A272E"
                filled
                solo
                dark
                placeholder="Enter the verification code"
                autofocus
                class="px-4"
                :rules="[rules.required, rules.otp]"
              />
            </v-row>
            <v-row class="px-4 mt-1 mb-4" no-gutters align="center" justify="center">
              <v-col align="center" no-gutters>
                <v-btn block dark class="mr-2 white1--text" color="#6c6c6c" @click="e1 = 2">
                  {{ $t('cancel') }}
                </v-btn>
              </v-col>

              <v-col class="ml-5" align="center" no-gutters>
                <v-btn
                  block
                  :loading="isGuestLogin"
                  :disabled="!verificationActive"
                  class="white1--text"
                  color="#289067"
                  @click="checkVerify"
                >
                  {{ $t('continue') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card>
  </v-dialog>
</template>

<script>
// import Toast from '@/views/meeting/component/Toast'
import { isMobile } from '@/common/lib/strLib'
import firebase from 'firebase/app'
import { setVerifyCode, checkVerify, setUserUpdate } from '@/services/api'
import Toast from '@/views/meeting/component/Toast'
import { mapGetters } from 'vuex'

export default {
  name: 'GuestIn',
  props: { guestInVisible: Boolean },
  data() {
    return {
      e1: 1,
      steps: 3,
      guestName: '',
      guestEmail: '',
      otp: '',
      isSendCodeLoading: false,
      isGuestLogin: false,
      dialogModel: true,
      rules: {
        required: '',
        counter: '',
        otp: '',
        email: '',
      },
      TermsofService:
        '<a href="https://taperlabs.notion.site/Terms-of-Service-91bdd3bad41448318c3d32d9a332b6b7">Terms of Service</a>',
      PrivacyPolicy:
        '<a href="https://taperlabs.notion.site/Privacy-Policy-770ef1b2cccb4defb2c085cda5f67de8">Privacy Policy</a>',
    }
  },
  mounted() {
    let typingTimer
    let doneTypingInterval = 600
    const emailField = document.getElementById('guest-in-email-text-field')

    emailField.addEventListener('keyup', () => {
      clearTimeout(typingTimer)
      this.rules = {
        required: '',
        counter: '',
        otp: '',
        email: '',
      }
      typingTimer = setTimeout(this.setRules, doneTypingInterval, this.$refs.guestEmailInput.validate())
    })

    emailField.addEventListener('keydown', () => {
      this.rules = {
        required: '',
        counter: '',
        otp: '',
        email: '',
      }
      clearTimeout(typingTimer)
    })
  },
  methods: {
    // setSignUp() {
    //   this.$store.dispatch('setSignInRedirectUrl', location.pathname)
    //   this.$router.push({ name: 'SignUp' })
    // },
    setSignIn() {
      this.$store.dispatch('setSignInRedirectUrl', location.pathname)
      this.$router.push({ name: 'SignIn' })
    },
    setRules() {
      this.rules = {
        required: (value) => !!value || 'Required',
        counter: (value) => value.length <= 30 || 'Max 30 characters',
        otp: (value) => value.length == 6 || 'Verification code is 6 characters',
        // email: (value) => {
        //   const pattern =
        //     /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        //   return pattern.test(value) || this.$t('msgCheckEmailFormat')
        // },
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          if (value.length > 0) return pattern.test(value) || this.$t('msgCheckEmailFormat')
          else return true
        },
      }
    },

    skipEmail() {
      // email 은 DB Table 필수 값이기 때문에 E(Empty) 로 넣어준다.
      this.setGuestLogin('E')
    },
    nextName() {
      this.e1 = 2
    },
    // esc 를 감지해서 dialog를 컨트롤
    controlEsc(event) {
      if (event.which === 27) this.close()
    },
    // Email 인증코드 전송
    async setVerifyCode() {
      this.isSendCodeLoading = true
      let result
      let error
      try {
        result = await setVerifyCode(this, this.guestEmail, 'signUp', true)
      } catch (err) {
        error = err
      } finally {
        this.isSendCodeLoading = false
        if (result && result === 'success') {
          // notify(this, 'Success', this.$t('msgSendVerifyCodeInfo'), 'success')
          const content = {
            component: Toast,
            props: {
              msg: this.$t('msgSendVerifyCodeInfo'),
              // submsg: '',
            },
          }
          this.$toast.success(content)
          this.e1 = 3
        } else if (error && error.response && error.response.data === 'userExist') {
          // notify(this, 'Error', this.$t('msgEmailAlreadyInUse'), 'error')
          const content = {
            component: Toast,
            props: {
              msg: this.$t('msgEmailAlreadyInUse'),
              // submsg: '',
            },
          }
          this.$toast.error(content)
        } else {
          // notify(this, 'Error', this.$t('general.seriousError'), 'error')
          const content = {
            component: Toast,
            props: {
              msg: this.$t('general.seriousError'),
              // submsg: '',
            },
          }
          this.$toast.error(content)
        }
      }
    },
    async checkVerify() {
      this.isGuestLogin = true
      let result
      let error

      // Email 인증코드 확인
      try {
        result = await checkVerify(this, this.guestEmail, 'signUp', this.otp)
      } catch (err) {
        error = err
      } finally {
        this.isGuestLogin = false
        // 인증이 성공하면
        if (result && result === 'success') {
          this.setGuestLogin()
        } else if (error && error.response && error.response.data === 'incorrectCode') {
          // notify(this, 'Error', this.$t('msgIncorrectCode'), 'error')
          const content = {
            component: Toast,
            props: {
              msg: this.$t('msgIncorrectCode'),
              // submsg: '',
            },
          }
          this.$toast.error(content)
        } else {
          // notify(this, 'Error', this.$t('general.seriousError'), 'error')
          const content = {
            component: Toast,
            props: {
              msg: this.$t('general.seriousError'),
              // submsg: '',
            },
          }
          this.$toast.error(content)
        }
      }
    },
    async setGuestLogin(email) {
      this.isGuestLogin = true
      let userResult
      let isSignIn = false
      // 게스트 로그인
      try {
        // 기존 익명 로그인 사용 안하도록 변경 - 20230417
        // userResult = await firebase.auth().signInAnonymously()

        // 게스트 로그인은 이메일 회원가입으로 처리하고, userStatus: G 로 추가
        // 회원가입 진행
        userResult = await firebase.auth().createUserWithEmailAndPassword(this.guestEmail, this.otp)
      } catch (error) {
        // 이미 가입되서 사용하고 있다면, Email 로그인으로 처리해준다.
        if (error && error.code === 'auth/email-already-in-use') {
          userResult = await firebase.auth().signInWithEmailAndPassword(this.guestEmail, this.otp)

          // 회원 DB에 email, userName 을 업데이트 해준다.
          await setUserUpdate(this, this.guestName, this.guestName)

          // Firebase 에 user profile 을 업데이트 해준다.
          await userResult.user.updateProfile({
            displayName: this.guestName,
          })
          isSignIn = true
        }
      } finally {
        this.isGuestLogin = false
      }
      this.isGuestLogin = true

      // 현재 유저 설정
      await this.$store.dispatch('setCurrentUser', userResult.user)
      // api header Authorization 설정
      await this.$store.dispatch('setApiHeader')

      try {
        // Email 주소 업데이트
        // await userResult.user.updateEmail(this.guestEmail)
        // DisplayName 업데이트
        // await firebase.auth().currentUser.updateProfile({
        //   displayName: this.guestName,
        // })
        // let displayName = userResult.user.displayName
        // displayName =
        //   (!displayName && displayName !== '') || (displayName && displayName === '') ? '빈값일경우' : displayName

        // Guest 로그인 (userStatus : G = 게스트)
        if (isSignIn) {
          await this.$store.dispatch('setSignIn', {
            deviceToken: '',
          })
          this.$store.dispatch('setFirebaseLog', {
            eventName: 'signin_with_guest',
            eventParam: {
              name: 'signin_with_guest',
              methodType: 'guest',
            },
          })
        }
        // 최초 Guest 로그인이면 가입 (userStatus : G = 게스트)
        else {
          await this.$store.dispatch('setSignUp', {
            userFullName: '',
            userDisplayName: this.guestName,
            deviceToken: '',
            userStatus: 'G',
            userEmail: email && email !== '' ? email : this.guestEmail,
          })

          this.$store.dispatch('setFirebaseLog', {
            eventName: 'signup_with_guest',
            eventParam: {
              name: 'signup_with_guest',
              methodType: this.chkMtPublic && this.chkMtPublic['isPublic'] ? 'share_link' : 'normal',
            },
          })
        }
      } catch (error) {
        console.log('guest login failed : ', error)
        // notify(this, 'Error', this.$t('general.seriousError'), 'error')
        const content = {
          component: Toast,
          props: {
            msg: this.$t('general.seriousError'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
      } finally {
        this.isGuestLogin = true
        this.close()
      }
    },
    close() {
      this.dialogModel = false
      this.$emit('close', 'close')
    },
  },
  computed: {
    ...mapGetters(['chkMtPublic']),
    isMobile() {
      return isMobile()
    },
    verificationActive() {
      if (this.otp && this.otp.length == 6) {
        return true
      } else {
        return false
      }
    },
    nameActive() {
      if (this.guestName) {
        return true
      } else {
        return false
      }
    },
    emailActive() {
      const pattern =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (pattern.test(this.guestEmail)) {
        return true
      } else {
        return false
      }
    },
  },
  watch: {
    steps(val) {
      if (this.e1 > val) {
        this.e1 = val
      }
    },
    guestInVisible(val) {
      this.dialogModel = val
    },
  },
}
</script>

<style scoped>
.v-dialog__content >>> .v-dialog {
  border-radius: 24px;
  overflow: hidden;
}
.v-stepper {
  background-color: #21343b !important;
  box-shadow: none !important;
}
.container-guest {
  border-radius: 24px !important;
}
.txt-guest-title {
  font-weight: 700;
  font-size: 18px;
  color: white;
  align-self: center;
}
.txt-guest-desc-name,
.txt-guest-desc-email,
.txt-guest-desc-verification {
  font-weight: 400;
  font-size: 15px;
  color: #96a7af;
  text-align: left;
}
.txt-guest-accent {
  font-weight: 600;
  color: #25c685;
}
.txt-guest-bold {
  font-weight: 600;
}
.container-btn >>> .v-btn * {
  font-size: 14px;
  color: white;
  letter-spacing: 0;
  text-transform: none;
  font-weight: bold;
}
.v-btn:disabled.v-btn--has-bg {
  background-color: #6c6c6c !important;
  color: #eee !important;
}
.v-text-field >>> .v-text-field__details {
  margin-top: 2px !important;
}
</style>
